exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboardSubcontractorsRate-9bdb2{margin-bottom:40px;padding:16px 24px;background-color:#fff}", ""]);

// Exports
exports.locals = {
	"dashboardSubcontractorsRate": "dashboardSubcontractorsRate-9bdb2"
};